export default (value: string | null) => {
    if (typeof document === 'undefined') return null;
    const expires = `; expires=${new Date(
        Date.now() + 86400000 // Milliseconds,  24 hours.
    ).toUTCString()}`;
    document.cookie =
        '_tidst' + '=' + (value || '') + expires + '; SameSite=Strict; path=/';
};
